/* global require  */
import * as React from "react";
import { Header } from "./Header";
import Progress from "./Progress";
import { AuthGuard } from "./AuthGuard";
import { OrderView } from "./OrderView";
export interface AppProps {
  title: string;
  isOfficeInitialized: boolean;
}

export default function App({ title, isOfficeInitialized }: AppProps) {
  if (!isOfficeInitialized) {
    return (
      <Progress
        title={title}
        logo={require("./../../../assets/logo-filled.png")}
        message="Sideload applikasjon for å bruke den"
      />
    );
  }

  return (
    <AuthGuard notLoggedInComponent={<div className="login">Du er ikke logget inn.</div>}>
      <>
        <Header />
        <section className="main-section">
          <OrderView />
        </section>
      </>
    </AuthGuard>
  );
}
